import styled from 'styled-components';

export const StyledRow = styled.div`
  display: flex;

  .col {
    width: 50%;

    & + .col {
      margin-left: 10px;
    }
  }

  & + .field {
    margin-top: 10px;
  }
`

export const StyledCol = styled.div`
  display: flex;
`
